
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.01 14.762L28.87.623a1.861 1.861 0 00-2.63 0L12.1 14.763a1.861 1.861 0 000 2.632l6.215 6.216 2.632-2.632-4.9-4.9 5.731-5.731 5.73 5.73-11.507 11.508L4.493 16.079 16 4.57l2.351 2.351 2.632-2.631L17.317.624a1.86 1.86 0 00-2.632 0L.545 14.762a1.862 1.862 0 000 2.632l14.14 14.14a1.861 1.861 0 002.631 0l4.46-4.46 4.462 4.46a1.864 1.864 0 002.632 0l14.14-14.14a1.861 1.861 0 000-2.632zM27.557 27.586L24.41 24.44l7.047-7.047a1.861 1.861 0 000-2.632L24.41 7.716l3.145-3.145L39.063 16.08 27.555 27.586z","fill":"url(#paint0_linear_71_27)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_71_27","x1":"21.777","y1":".078","x2":"21.777","y2":"32.078","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FC25B7"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF7832"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF7832"}})])])])
          )
        }
      }
    